import { defineMessages } from 'react-intl';

const messages = defineMessages({
  eventDetails: {
    id: 'google-calendar-event-details.eventDetails',
    defaultMessage: 'DETAILS',
  },
  eventDate: {
    id: 'google-calendar-event-details.eventDate',
    defaultMessage: 'When',
  },
  eventPlace: {
    id: 'google-calendar-event-details.eventPlace',
    defaultMessage: 'Where',
  },
  eventGuests: {
    id: 'google-calendar-event-details.eventGuests',
    defaultMessage: 'Guests',
  },
  eventDescription: {
    id: 'google-calendar-event-details.eventDescription',
    defaultMessage: 'Description',
  },
  eventMoreDetails: {
    id: 'google-calendar-event-details.eventMoreDetails',
    defaultMessage: '<b>See more details</b> in Google Calendar',
  },
  eventStatusConfirmed: {
    id: 'google-calendar-event-details.eventStatusConfirmed',
    defaultMessage: 'Confirmed',
  },
  eventStatusAwaiting: {
    id: 'google-calendar-event-details.eventStatusAwaiting',
    defaultMessage: 'Awaiting',
  },
  eventAllDay: {
    id: 'google-calendar-event-details.eventAllDay',
    defaultMessage: 'All Day',
  },
});

export default messages;
